import React from "react";

function Icon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 78.409 56.369" className={className}>
      <g transform="translate(11.363 4.5)" opacity="0.573">
        <path
          d="M18.909,9.314a3.532,3.532,0,1,0-3.532-3.532A3.52,3.52,0,0,0,18.909,9.314Z"
          transform="translate(-10.955 -2.25)"
          fill="#b9b9b9"
        />
        <path
          d="M23.59,8.086H16.507a4.533,4.533,0,0,0-4.413,4.583V23.426a1.471,1.471,0,1,0,2.936,0V13.484H15.6V40.528a2.038,2.038,0,1,0,4.072,0V24.942h.758v15.6a2.037,2.037,0,1,0,4.072-.009V13.484h.473v9.943a1.516,1.516,0,1,0,3.03,0V12.669A4.546,4.546,0,0,0,23.59,8.086Z"
          transform="translate(-12.094 -0.226)"
          fill="#b9b9b9"
        />
      </g>
      <g transform="translate(47.727 4.485)" opacity="0.573">
        <path
          d="M14.127,11.268l-2.784,9.877c-.6,2.159,1.96,3,2.585.975l2.49-9.11h.7l-4.28,16h4V41.04a1.519,1.519,0,1,0,3.03,0V29.013h.947V41.04a1.476,1.476,0,1,0,2.936,0V29.013h4.11l-4.375-16h.8l2.49,9.11c.616,2.074,3.153,1.184,2.585-.966L26.57,11.268a4.7,4.7,0,0,0-3.977-3.182H18.114A4.521,4.521,0,0,0,14.127,11.268Z"
          transform="translate(-11.254 -0.217)"
          fill="#b9b9b9"
        />
        <path
          d="M22.358,5.775a3.466,3.466,0,1,0-6.932,0,3.466,3.466,0,1,0,6.932,0Z"
          transform="translate(-9.807 -2.243)"
          fill="#b9b9b9"
        />
      </g>
      <g transform="translate(28.409 0)" opacity="0.573">
        <path
          d="M14.127,11.268l-2.784,9.877c-.6,2.159,1.96,3,2.585.975l2.49-9.11h.7l-4.28,16h4V41.04a1.519,1.519,0,1,0,3.03,0V29.013h.947V41.04a1.476,1.476,0,1,0,2.936,0V29.013h4.11l-4.375-16h.8l2.49,9.11c.616,2.074,3.153,1.184,2.585-.966L26.57,11.268a4.7,4.7,0,0,0-3.977-3.182H18.114A4.521,4.521,0,0,0,14.127,11.268Z"
          transform="translate(-11.254 -0.217)"
          fill="#b9b9b9"
        />
        <path
          d="M22.358,5.775a3.466,3.466,0,1,0-6.932,0,3.466,3.466,0,1,0,6.932,0Z"
          transform="translate(-9.807 -2.243)"
          fill="#b9b9b9"
        />
      </g>
      <g transform="translate(0 13.928)">
        <path
          d="M18.909,9.314a3.532,3.532,0,1,0-3.532-3.532A3.52,3.52,0,0,0,18.909,9.314Z"
          transform="translate(-10.955 -2.25)"
          fill="#707070"
        />
        <path
          d="M23.59,8.086H16.507a4.533,4.533,0,0,0-4.413,4.583V23.426a1.471,1.471,0,1,0,2.936,0V13.484H15.6V40.528a2.038,2.038,0,1,0,4.072,0V24.942h.758v15.6a2.037,2.037,0,1,0,4.072-.009V13.484h.473v9.943a1.516,1.516,0,1,0,3.03,0V12.669A4.546,4.546,0,0,0,23.59,8.086Z"
          transform="translate(-12.094 -0.226)"
          fill="#707070"
        />
      </g>
      <g transform="translate(40.91 13.928)">
        <path
          d="M18.909,9.314a3.532,3.532,0,1,0-3.532-3.532A3.52,3.52,0,0,0,18.909,9.314Z"
          transform="translate(-10.955 -2.25)"
          fill="#707070"
        />
        <path
          d="M23.59,8.086H16.507a4.533,4.533,0,0,0-4.413,4.583V23.426a1.471,1.471,0,1,0,2.936,0V13.484H15.6V40.528a2.038,2.038,0,1,0,4.072,0V24.942h.758v15.6a2.037,2.037,0,1,0,4.072-.009V13.484h.473v9.943a1.516,1.516,0,1,0,3.03,0V12.669A4.546,4.546,0,0,0,23.59,8.086Z"
          transform="translate(-12.094 -0.226)"
          fill="#707070"
        />
      </g>
      <g transform="translate(19.318 13.912)">
        <path
          d="M14.127,11.268l-2.784,9.877c-.6,2.159,1.96,3,2.585.975l2.49-9.11h.7l-4.28,16h4V41.04a1.519,1.519,0,1,0,3.03,0V29.013h.947V41.04a1.476,1.476,0,1,0,2.936,0V29.013h4.11l-4.375-16h.8l2.49,9.11c.616,2.074,3.153,1.184,2.585-.966L26.57,11.268a4.7,4.7,0,0,0-3.977-3.182H18.114A4.521,4.521,0,0,0,14.127,11.268Z"
          transform="translate(-11.254 -0.217)"
          fill="#707070"
        />
        <path
          d="M22.358,5.775a3.466,3.466,0,1,0-6.932,0,3.466,3.466,0,1,0,6.932,0Z"
          transform="translate(-9.807 -2.243)"
          fill="#707070"
        />
      </g>
      <g transform="translate(60.227 13.912)">
        <path
          d="M14.127,11.268l-2.784,9.877c-.6,2.159,1.96,3,2.585.975l2.49-9.11h.7l-4.28,16h4V41.04a1.519,1.519,0,1,0,3.03,0V29.013h.947V41.04a1.476,1.476,0,1,0,2.936,0V29.013h4.11l-4.375-16h.8l2.49,9.11c.616,2.074,3.153,1.184,2.585-.966L26.57,11.268a4.7,4.7,0,0,0-3.977-3.182H18.114A4.521,4.521,0,0,0,14.127,11.268Z"
          transform="translate(-11.254 -0.217)"
          fill="#707070"
        />
        <path
          d="M22.358,5.775a3.466,3.466,0,1,0-6.932,0,3.466,3.466,0,1,0,6.932,0Z"
          transform="translate(-9.807 -2.243)"
          fill="#707070"
        />
      </g>
    </svg>
  );
}

export { Icon };
